/**
 * The strings are mapped to the existing Identity Providers in Cognito.
 */
export enum IdPs {
    OTP = 'OTP',
    AWSBuilderID = 'AWSBuilderID',
    LoginWithAmazon = 'LoginWithAmazon',
    AmazonFederate = 'AmazonFederate',
    AmazonSystemFederate = 'AmazonSystemFederate',
    AWSPartnerNetwork = 'AWSPartnerNetwork',
    None = 'None',
    OrganizationSSO = 'COGNITO',
}
